import { useQuery } from '@tanstack/react-query'
import { isVirtualFolderId } from '../domains/folder/utils/virtualFolder'

export type FolderAccessInfo = { role: 'viewer'|'editor'|'moderator'|'owner'|'none'; canWrite: boolean; source: 'auth'|'link' }

export function useFolderAccess(folderId?: string) {
  const enabled = Boolean(folderId && !isVirtualFolderId(folderId))
  return useQuery<FolderAccessInfo>({
    queryKey: ['folder', folderId, 'access'],
    enabled,
    queryFn: async () => {
      if (!folderId || isVirtualFolderId(folderId)) {
        return { role: 'none', canWrite: false, source: 'auth' }
      }
      // Try auth-based access first
      try {
        const r = await fetch(`/api/folders/${folderId}/access`, { credentials: 'include' })
        if (r.ok) {
          const j = await r.json()
          if (j && j.role && j.role !== 'none') return { ...(j as Omit<FolderAccessInfo, 'source'>), source: 'auth' }
        }
      } catch {}
      // Try link-based access
      try {
        const r2 = await fetch(`/api/link/folders/${folderId}/access`, { credentials: 'include' })
        if (r2.ok) {
          const j2 = await r2.json()
          return { ...(j2 as Omit<FolderAccessInfo, 'source'>), source: 'link' }
        }
      } catch {}
      return { role: 'none', canWrite: false, source: 'auth' }
    },
    staleTime: 30_000,
  })
}

